<div class="page-about page-esal-docs">
  <section class="section-title">
    <h1>
      Requisitos de permanencia <br />
      Regimen Tributario Especial - ESAL
    </h1>
  </section>

  <section class="section-green">
    <br />
    <br />
    <section class="contenedor-cards">
      <!-- Card #1 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Acta de constitución</h3>
        <div>
          <a href="../../../assets/esal-docs/ACTA-DE-CONSTITUCION.pdf" download>Descargar PDF</a>
        </div>
      </div>
  
      <!-- Card #2 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Certificación antecedentes judiciales</h3>
        <div>
        <a href="../../../assets/esal-docs/CERTIFICACION-ANTECEDENTES-JUDICIALES.pdf" download>Descargar PDF</a>
      </div>
    </div>
  
      <!-- Card #3 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Certificación representante legal y fiscal</h3>
        <div>
        <a href="../../../assets/esal-docs/CERTIFICACION-REPRESENTANTE-LEGAL-Y-FISCAL.pdf" download>Descargar PDF</a>
      </div>
    </div>

      <!-- Card #4 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Certificado de existencia</h3>
        <div>
        <a href="../../../assets/esal-docs/CERTIFICADO-DE-EXISTENCIA.pdf" download>Descargar PDF</a>
      </div>
    </div>

      <!-- Card #5 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Estados financieros 2024</h3>
        <div>
        <a href="../../../assets/esal-docs/ESTADOS-FINANCIEROS-2024.pdf" download>Descargar PDF</a>
      </div>
    </div>
  
      <!-- Card #6 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Estatutos Fundación Soliun</h3>
        <div>
        <a href="../../../assets/esal-docs/ESTATUTOS-FUNDACION-SOLIUN.pdf" download>Descargar PDF</a>
      </div>
    </div>

      <!-- Card #7 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Formulario renta año 2024</h3>
        <div>
        <a href="../../../assets/esal-docs/FORMULARIO-RENTA-2024.pdf" download>Descargar PDF</a>
      </div>
    </div>
  
      <!-- Card #8 -->
      <div class="card">
        <i class="fas fa-file-pdf"></i>
        <h3>Informe de gestión 2024</h3>
        <div>
        <a href="../../../assets/esal-docs/INFORME-DE-GESTION-2024.pdf" download>Descargar PDF</a>
      </div>
    </div>
    </section>
  </section>

  <section class="section-pink">
   
  </section>

  <section class="section-green">
    
  </section>
</div>
